import { ReactNode } from 'react';
import { useSnackbar } from '@swat-sccs/react-simple-snackbar';
import { CircleAlert, CircleCheck, X } from 'lucide-react';

type SnackbarTone = 'success' | 'error' | 'neutral';

const DEFAULT_DURATION: Record<SnackbarTone, number> = {
    success: 3500,
    error: 6000,
    neutral: 5000,
};

const ICONS = {
    success: CircleCheck,
    error: CircleAlert,
};

export const useAppSnackbar = () => {
    const [open, close] = useSnackbar({ position: 'top-center' });

    const show = (tone: SnackbarTone) => (content: ReactNode, duration: number = DEFAULT_DURATION[tone]) => {
        const Icon = tone === 'neutral' ? null : ICONS[tone];

        open(
            <div className="sf-toast" data-tone={tone} role={tone === 'error' ? 'alert' : 'status'}>
                {Icon && <Icon className="sf-toast-icon" aria-hidden="true" />}
                <div className="sf-toast-body">{content}</div>
                <button type="button" className="sf-toast-close" aria-label="Fechar" onClick={close}>
                    <X aria-hidden="true" />
                </button>
            </div>,
            duration
        );
    };

    return {
        successSnackbar: show('success'),
        errorSnackbar: show('error'),
        neutralSnackbar: show('neutral'),
        closeSnackbar: close,
    };
};
